import styled from 'styled-components';

const AccessModuleWrapper = styled.div``;

export { AccessModuleWrapper };
